import { render, staticRenderFns } from "./DenunciaResultado.vue?vue&type=template&id=6d289998&lang=pug"
import script from "./DenunciaResultado.vue?vue&type=script&lang=js"
export * from "./DenunciaResultado.vue?vue&type=script&lang=js"
import style0 from "./DenunciaResultado.vue?vue&type=style&index=0&id=6d289998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports